
/* ts-sitewide-collection-ux-20260722T140137Z */
(function(){
  'use strict';
  if (!document.body || !document.body.classList.contains('template-collection')) return;

  var pageRoots = [
    { selector: '[data-ts-headunits]', panel: '.ts-headunits__filters', grid: '.ts-headunits__group', toggle: true },
    { selector: '[data-ts-speakers]', panel: '.ts-speakers-filter', grid: '.ts-speakers-collection__grid', toggle: true },
    { selector: '.ts-collection', panel: '[data-ts-collection-filters]', grid: '.ts-product-grid', toggle: false },
    { selector: '[id^="ts-subwoofers-"]', panel: '.ts-subwoofers__filters', grid: '.ts-subwoofers__grid', toggle: false }
  ];
  var applyingState = false;
  var stateKeys = {};

  function safeKey(value){ return String(value || '').replace(/[^a-zA-Z0-9_-]/g, ''); }
  function rootKey(root){ return safeKey(root.getAttribute('data-ts-headunits') === '' ? 'headunits' : root.className || root.id || 'collection'); }
  function panelFor(root, config){ return root.querySelector(config.panel); }
  function fieldLabel(field){
    var label = field.querySelector('label, .ts-filter-panel__label, .ts-speakers-choice__label');
    return label ? label.textContent.replace(/s+/g, ' ').trim() : (field.getAttribute('data-filter') || 'Filter');
  }
  function getState(root, config){
    var panel = panelFor(root, config), state = {};
    if (!panel) return state;
    panel.querySelectorAll('select[data-filter]').forEach(function(select){ if (select.value) state[select.getAttribute('data-filter')] = select.value; });
    panel.querySelectorAll('[data-filter][data-value]').forEach(function(field){ if (field.dataset.value) state[field.getAttribute('data-filter')] = field.dataset.value; });
    panel.querySelectorAll('[data-processor-state].is-active, [data-dsp-state].is-active').forEach(function(button){
      var key = button.hasAttribute('data-processor-state') ? 'processorType' : 'builtInDsp';
      var value = button.getAttribute(button.hasAttribute('data-processor-state') ? 'data-processor-state' : 'data-dsp-state');
      if (value) state[key] = value;
    });
    panel.querySelectorAll('[data-filter-group][aria-pressed="true"]').forEach(function(button){ state[button.getAttribute('data-filter-group')] = button.getAttribute('data-filter-value'); });
    return state;
  }
  function stateFromUrl(){
    var params = new URLSearchParams(window.location.search), state = {};
    params.forEach(function(value, key){ if (key.indexOf('tsux_') === 0 && value) state[key.slice(5)] = value; });
    return state;
  }
  function writeState(root, config){
    if (applyingState) return;
    var state = getState(root, config), url = new URL(window.location.href), next = {};
    Object.keys(stateKeys).forEach(function(key){ url.searchParams.delete('tsux_' + key); });
    Object.keys(state).forEach(function(key){ url.searchParams.set('tsux_' + key, state[key]); next[key] = true; });
    stateKeys = next;
    if (url.href !== window.location.href) window.history.pushState({ tsCollectionUX: true }, '', url.toString());
    renderChips(root, config, state);
  }
  function renderChips(root, config, state){
    var panel = panelFor(root, config), existing = root.querySelector('[data-tsux-chips]');
    if (!panel) return;
    if (!existing) { existing = document.createElement('div'); existing.setAttribute('data-tsux-chips',''); existing.className = 'ts-sitewide-filter-chips'; panel.parentNode.insertBefore(existing, panel.nextSibling); }
    existing.innerHTML = '';
    Object.keys(state).forEach(function(key){
      var value = state[key], chip = document.createElement('button');
      chip.type = 'button'; chip.className = 'ts-sitewide-filter-chip'; chip.dataset.tsuxRemove = key;
      chip.textContent = fieldLabel(panel.querySelector('[data-filter="' + CSS.escape(key) + '"]') || panel.querySelector('[data-filter-group="' + CSS.escape(key) + '"]') || panel) + ': ' + value + ' ×';
      existing.appendChild(chip);
    });
    if (Object.keys(state).length) {
      var clear = document.createElement('button'); clear.type = 'button'; clear.className = 'ts-sitewide-filter-chip ts-sitewide-filter-chip--clear'; clear.dataset.tsuxClear = 'true'; clear.textContent = 'Clear filters'; existing.appendChild(clear);
    }
    existing.hidden = Object.keys(state).length === 0;
  }
  function ensureToggle(root, config){
    var panel = panelFor(root, config); if (!panel) return;
    var toggle = root.querySelector('[data-filter-toggle]');
    if (!toggle && config.toggle) {
      var tools = document.createElement('div'); tools.className = 'ts-sitewide-filter-tools';
      toggle = document.createElement('button'); toggle.type = 'button'; toggle.className = 'ts-sitewide-filter-toggle'; toggle.textContent = 'Filters'; toggle.setAttribute('aria-expanded','false'); toggle.dataset.filterToggle = 'true';
      var hint = document.createElement('span'); hint.className = 'ts-sitewide-filter-tools__hint'; hint.textContent = 'Optional — browse the collection first.';
      tools.appendChild(toggle); tools.appendChild(hint); panel.parentNode.insertBefore(tools, panel);
    }
    if (toggle && !toggle.dataset.tsuxReady) {
      toggle.dataset.tsuxReady = 'true';
      panel.classList.add('ts-sitewide-filter-panel');
      panel.id = panel.id || ('ts-sitewide-filter-panel-' + Math.random().toString(36).slice(2));
      toggle.setAttribute('aria-controls', panel.id);
      if (!toggle.hasAttribute('aria-expanded')) toggle.setAttribute('aria-expanded','false');
      if (config.toggle && !panel.hidden) panel.hidden = true;
      toggle.addEventListener('click', function(){ var open = panel.hidden; panel.hidden = !open; toggle.setAttribute('aria-expanded', open ? 'true' : 'false'); toggle.textContent = open ? 'Hide filters' : 'Filters'; });
    }
  }
  function applyUrlState(root, config){
    var desired = stateFromUrl(), panel = panelFor(root, config); if (!panel || !Object.keys(desired).length) return;
    applyingState = true;
    panel.querySelectorAll('select[data-filter]').forEach(function(select){ if (desired[select.getAttribute('data-filter')] !== undefined) { select.value = desired[select.getAttribute('data-filter')]; select.dispatchEvent(new Event('change', { bubbles: true })); } });
    Object.keys(desired).forEach(function(key){
      var value = desired[key], button = panel.querySelector('[data-processor-state="' + CSS.escape(value) + '"]') || panel.querySelector('[data-dsp-state="' + CSS.escape(value) + '"]') || panel.querySelector('[data-filter-group="' + CSS.escape(key) + '"][data-filter-value="' + CSS.escape(value) + '"]');
      if (button) { button.click(); return; }
      var field = panel.querySelector('[data-filter="' + CSS.escape(key) + '"]');
      if (field) { var option = field.querySelector('[data-filter-options] [data-value="' + CSS.escape(value) + '"]'); if (option) option.click(); }
    });
    applyingState = false;
    renderChips(root, config, getState(root, config));
  }
  function wire(root, config){
    if (root.dataset.tsSitewideUXReady === 'true') return;
    var panel = panelFor(root, config); if (!panel) return;
    root.dataset.tsSitewideUXReady = 'true'; ensureToggle(root, config);
    root.addEventListener('change', function(event){ if (event.target.matches('select[data-filter]')) window.setTimeout(function(){ writeState(root, config); }, 50); });
    root.addEventListener('click', function(event){
      var action = event.target.closest('[data-filter-trigger], [data-filter-clear], [data-clear-filters], [data-filter-group], [data-filter-toggle], [data-tsux-remove], [data-tsux-clear]');
      if (!action) return;
      if (action.hasAttribute('data-tsux-remove')) {
        event.preventDefault(); var key = action.dataset.tsuxRemove, field = panel.querySelector('[data-filter="' + CSS.escape(key) + '"]');
        var blank = field && field.querySelector('[data-filter-options] [data-value=""]');
        if (blank) blank.click(); else { var select = panel.querySelector('select[data-filter="' + CSS.escape(key) + '"]'); if (select) { select.value=''; select.dispatchEvent(new Event('change',{bubbles:true})); } }
      } else if (action.hasAttribute('data-tsux-clear')) {
        event.preventDefault(); var clear = panel.querySelector('[data-filter-clear], [data-clear-filters]'); if (clear) clear.click();
      }
      window.setTimeout(function(){ writeState(root, config); }, 80);
    });
    renderChips(root, config, getState(root, config));
    applyUrlState(root, config);
  }
  function scan(){ pageRoots.forEach(function(config){ document.querySelectorAll(config.selector).forEach(function(root){ wire(root, config); }); }); }
  function onPopState(){ if (document.querySelector('[data-ts-sitewide-ux-ready]')) window.location.reload(); else scan(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.addEventListener('popstate', onPopState);
  var observer = new MutationObserver(function(){ scan(); }); observer.observe(document.documentElement, { childList: true, subtree: true });
})();
